export interface RunningActionState {
    actions: string[];
}

const initialRunningActionState: RunningActionState = {
    actions: [],
};

export function getInitialRunningActionState(): RunningActionState {
    return initialRunningActionState;
}
